module.exports = __webpack_public_path__ + "media/images/svg/youtube-501d8c1a9f23bbc25b6b9aa57fc46567.svg";